module.exports = __webpack_public_path__ + "img/brand-block-2.63d57f51.png";